import _ from 'lodash';
import {freqMap, getDonationProduct, getFormData, getProducts, isProductForm, paymentMethodMap} from '../helpers';

export function gaStep4(formContext, callback) {
  return (dispatch, getState) => {
    const state = getState();
    const data = getFormData(state);
    const amount = data.amount_m || data.customAmount_m;
    let yearlyAmount = _.multiply(amount, freqMap[data.frequency || 'oneOff'].times);
    const hasNewsletter = formContext.allowNewsletter;
    const hasTelemarketing = formContext.telemarketingOptIn !== 'none';

    if (formContext.mandateType === 'temporary' && data.frequency === 'monthly') {
      yearlyAmount = _.multiply(amount, _.toInteger(data.period));
    }

    if (!amount || !formContext) {
      if (_.isFunction(callback)) return callback();
      return;
    }

    const paymentMethod = paymentMethodMap[data.paymentMethod] || 'machtiging';
    let ecomEvent;

    if (isProductForm(formContext)) {
      window.dataLayer.push({
        'event': 'transactionSend',
        'ecommerce': {
          'purchase': {
            'actionField': {
              id: data.referenceKey,
              affiliation: 'Online Store',
              revenue: data.amount_m,
              tax: '0.00',
              shipping: '0.00',
              action: 'purchase'
            },
            products: getProducts(formContext, state)
          }
        }
      });

      ecomEvent = {
        'event': 'checkout',
        'newsletterSubscription': hasNewsletter ? !!_.get(data, ['allowNewsletter']) : undefined,
        'telemarketing': hasTelemarketing ? (!!_.get(data, ['allowTelemarketing']) && !!_.get(data, ['telephone'])) : undefined,
        'contactType': _.get(data, ['donateAsOrganisation'], false) ? 'organisation' : 'individual',
        'ecommerce': {
          'checkout': {
            'actionField': {
              'step': 4,
              'option': paymentMethod
            },
            products: getProducts(formContext, state)
          }
        }
      };
    } else {
      ecomEvent = {
        'ecommerce': {
          'purchase': {
            'actionField': {
              id: data.referenceKey,
              affiliation: 'donatiemodule',
              revenue: yearlyAmount.toFixed(2),
              tax: '0.00'
            },
            'products': getDonationProduct(formContext, state)
          }
        },
        'newsletterSubscription': hasNewsletter ? !!_.get(data, ['allowNewsletter']) : undefined,
        'telemarketing': hasTelemarketing ? (!!_.get(data, ['allowTelemarketing']) && !!_.get(data, ['telephone'])) : undefined,
        'contactType': _.get(data, ['donateAsOrganisation'], false) ? 'organisation' : 'individual',
        'event': 'ecomPurchase'
      };
    }

    if (_.isFunction(callback)) {
      ecomEvent.eventCallback = () => {
        callback();
      };
      ecomEvent.eventTimeout = 2000;

      // Final timeout to make sure it works
      setTimeout(callback, 3000);
    }
    window.dataLayer.push(ecomEvent);

    if (data.email) {
      const utf8 = new TextEncoder().encode(data.email);

      if (!crypto.subtle) {
        return;
      }

      return crypto.subtle.digest('SHA-256', utf8).then((hashBuffer) => {
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        const hashHex = hashArray.map(bytes => bytes.toString(16).padStart(2, '0')).join('');

        window.dataLayer.push({
          'email': hashHex,
          'event': 'fireEnhancedConversionTag'
        });
      });
    }
  };
}
